import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../store';
import type { Role } from '@ads-manager/shared';

interface RoleRouteProps {
  roles: Role[];
}

export const RoleRoute = ({ roles }: RoleRouteProps) => {
  const { user, hasRole } = useAuthStore();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!hasRole(roles)) {
    // Redirect to appropriate dashboard based on role
    switch (user.role) {
      case 'TRAFFIC_MANAGER':
        return <Navigate to="/tm/dashboard" replace />;
      case 'ACCOUNT_MANAGER':
        return <Navigate to="/am/dashboard" replace />;
      case 'CONTRACTOR':
        return <Navigate to="/contractor/dashboard" replace />;
      case 'BRANCH':
        return <Navigate to="/branch/dashboard" replace />;
      default:
        return <Navigate to="/login" replace />;
    }
  }

  return <Outlet />;
};

export default RoleRoute;
